import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import { object, bool, func, element } from 'prop-types'

export const ErrorDialog = ({
  isOpen = false,
  onClose = () => {},
  error = {},
  actionButtons = <div />,
}) => {
  return (
    <Dialog onClose={onClose} open={isOpen}>
      <>
        <DialogTitle style={{ minWidth: '350px' }}>{error.title}</DialogTitle>
        <div style={{ padding: 24, paddingTop: 8, minWidth: '350px' }}>
          <Typography>{error.description}</Typography>
        </div>
        <DialogActions style={{ display: 'flex', minWidth: '350px' }}>
          {actionButtons}
        </DialogActions>
      </>
    </Dialog>
  )
}

ErrorDialog.propTypes = {
  isOpen: bool,
  onClose: func,
  error: object,
  actionButtons: element,
}
